import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { RemoveFreeMemberRequest } from '../../domain/dtos/free-member'
import { QueryKey } from '../../domain/enums/query-key'
import { RemoveFreeMember } from '../../usecases/remove-free-member'

export const useRemoveFreeMember = () => {
  const container = useContainer()
  const queryClient = useQueryClient()

  return useMutation(
    [QueryKey.removeFreeMember],
    (input: RemoveFreeMemberRequest) => new RemoveFreeMember(container.get(HttpClient)).execute(input),
    {
      retry: false,
      onSuccess: () => queryClient.invalidateQueries([QueryKey.getFreeMembers]),
    },
  )
}
